import BreadCrumb from 'Common/BreadCrumb';
import React from 'react';
import { Container } from 'react-bootstrap';
// Import Components


const Ecommerce = () => {
    document.title = "Admin | Azerbaijan Tours ";

    
    return (
        <React.Fragment>
            <div className ="page-content">
                <Container fluid>
                    <BreadCrumb title="Admin" pageTitle="Azerbaijan Tours" />
                </Container>
    
            </div>
        </React.Fragment>
        
    );
};

export default Ecommerce;
